import { Injectable } from '@angular/core';
import { CaiApi } from '../../utils/cai-api';
import { IRateStatus } from '../../model/rate-status.model';
import { API_CORE } from '../../constant/api-core.const';

@Injectable({
  providedIn: 'root',
})
export class RateStatusService {
  async getRateStatuses(
    airlineBrandCode: string,
    officeId: number,
    countryCode: string,
  ): Promise<IRateStatus[]> {
    const extraOptions: any = {
      queryParams: {},
    };
    if (airlineBrandCode) {
      extraOptions.queryParams.airline = airlineBrandCode;
    }
    if (officeId) {
      extraOptions.queryParams.officeId = officeId;
    }
    if (countryCode) {
      extraOptions.queryParams.country = countryCode;
    }
    return CaiApi.get(
      API_CORE.name,
      API_CORE.URLs.RateStatus.RateStatus,
      extraOptions,
    );
  }

  async createOrUpdateRateStatus(
    rateStatus: IRateStatus,
  ): Promise<IRateStatus> {
    return CaiApi.post(API_CORE.name, API_CORE.URLs.RateStatus.RateStatus, {
      body: rateStatus,
    });
  }

  async deleteRateStatus(id: number): Promise<IRateStatus> {
    const url = API_CORE.URLs.RateStatus.RateStatus.concat('/').concat(
      id.toString(),
    );
    return CaiApi.del(API_CORE.name, url, {});
  }
}
